var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.color ? "color: " + _vm.color + ";" : "" },
    [
      _vm.editMode
        ? [
            _c(
              "v-layout",
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    id: "bank_name",
                    label: _vm.$t("bankName"),
                    rules: [_vm.fieldIsRequired("bank name")],
                    hint: _vm.$t("paymentBillPayWidget")
                  },
                  on: { keyup: _vm.onChange },
                  model: {
                    value: _vm.localValue.bankName,
                    callback: function($$v) {
                      _vm.$set(_vm.localValue, "bankName", $$v)
                    },
                    expression: "localValue.bankName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("v-layout", {
              attrs: { "align-baseline": "", "justify-space-between": "" }
            }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        id: "account_holder",
                        label: _vm.$t("accountHolderName"),
                        rules: [_vm.fieldIsRequired("holder name")]
                      },
                      on: { keyup: _vm.onChange },
                      model: {
                        value: _vm.localValue.accountHolder,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "accountHolder", $$v)
                        },
                        expression: "localValue.accountHolder"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-select", {
                      staticClass: "required_field",
                      attrs: {
                        items: _vm.currencies,
                        rules: [_vm.fieldIsRequired("currency")],
                        label: _vm.$t("currency")
                      },
                      model: {
                        value: _vm.localValue.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "currency", $$v)
                        },
                        expression: "localValue.currency"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "justify-space-between": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        id: "routing_number",
                        label: _vm.$t("routingNumber")
                      },
                      on: { keyup: _vm.onChange },
                      model: {
                        value: _vm.localValue.routingNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "routingNumber", $$v)
                        },
                        expression: "localValue.routingNumber"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { sm4: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        id: "account_number",
                        label: _vm.$t("accountNumber"),
                        rules: [_vm.fieldIsRequired("account number")]
                      },
                      on: { keyup: _vm.onChange },
                      model: {
                        value: _vm.localValue.accountNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.localValue, "accountNumber", $$v)
                        },
                        expression: "localValue.accountNumber"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    id: "account_address",
                    label: _vm.$t("bankAddress"),
                    rules: [_vm.fieldIsRequired("account address")]
                  },
                  on: { keyup: _vm.onChange },
                  model: {
                    value: _vm.localValue.address,
                    callback: function($$v) {
                      _vm.$set(_vm.localValue, "address", $$v)
                    },
                    expression: "localValue.address"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c("v-text-field", {
                  staticClass: "required_field",
                  attrs: {
                    id: "billing_address",
                    label: _vm.$t("billingAddress"),
                    rules: [_vm.fieldIsRequired("billing address")]
                  },
                  on: { keyup: _vm.onChange },
                  model: {
                    value: _vm.localValue.billingAddress,
                    callback: function($$v) {
                      _vm.$set(_vm.localValue, "billingAddress", $$v)
                    },
                    expression: "localValue.billingAddress"
                  }
                })
              ],
              1
            )
          ]
        : [
            _vm.fullDetail
              ? _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("bankName")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.bankName))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("currency")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.currency))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("accountHolder")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.accountHolder))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("routingNumber")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.routingNumber))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("account")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.accountNumber))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("bankAddress")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.address))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { sm6: "", md4: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.$t("billingAddress")) + ":")
                                ]),
                                _c("v-flex", { attrs: { sm6: "" } }, [
                                  _vm._v(_vm._s(_vm.localValue.billingAddress))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "v-layout",
                  { attrs: { column: "" } },
                  [
                    _c("v-flex", [
                      _vm._v(
                        _vm._s(_vm.localValue.bankName) +
                          " * " +
                          _vm._s(_vm.localValue.currency) +
                          " * " +
                          _vm._s(_vm.localValue.accountHolder) +
                          " * " +
                          _vm._s(_vm.localValue.routingNumber) +
                          " * " +
                          _vm._s(
                            _vm.localValue.accountNumber &&
                              _vm.localValue.accountNumber.replace(
                                /(.{4})/g,
                                "$1 "
                              )
                          ) +
                          " * " +
                          _vm._s(_vm.localValue.address)
                      )
                    ])
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37cdcb91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cdcb91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentBankTransferWidget.vue
// module id = null
// module chunks = 